export default "__VITE_PUBLIC_ASSET__c16d68c8__"